import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { ToothStateComponent } from '../tooth-state/tooth-state.component';
import { ToothFaceTypeService } from '../../../services/toothFaceType.service';
import { ToothStateDetailService } from '../../../services/toothStateDetail.service';
import { ToastrService, Toast } from 'ngx-toastr';
import { ToothStateTypeService } from '../../../services/toothStateType.service';
import { forkJoin, Subscription } from 'rxjs';
import { BOToothFaceType } from '../../../models/odo/BOToothFaceType.model';
import { BOToothStateDetail } from '../../../models/odo/BOToothStateDetail.model';
import { BOToothStateType } from '../../../models/odo/BOToothStateType.model';
import { ActivatedRoute, Router, Event } from '@angular/router';
import { take } from 'rxjs/operators';
import { PersonService } from '../../../services/person.service';
import { BOPerson } from '../../../models/BOPerson.model';
import { BOToothStateDetailAgrouped } from '../../../models/BOToothStateDetailAgroupe.model';
import { Utilities } from '../../../common/utilities';
import { BOToothStateDetailToothFace } from '../../../models/odo/BOToothStateDetailToothFace.model';
import { BOToothStateDetailToohtState } from '../../../models/odo/BOToothStateDetailToothState.model';

@Component({
  selector: 'app-odontograma',
  templateUrl: './odontograma.component.html',
  styleUrls: ['./odontograma.component.css']
})


export class OdontogramaComponent implements AfterViewInit, OnInit, OnDestroy{
  @ViewChild('toothState', { static: true }) toothState!: ToothStateComponent;
  @ViewChild('svgContainer') svgContainer!: ElementRef<SVGSVGElement>;
  @ViewChildren('svgContainer') svgContainers!: QueryList<ElementRef>;


  busyData$:Subscription;
  bridgeElement: any;
  clinicHistoryId:number=null;
  personId:number=null;
  personDocumentId:number=null;
  odontogramaId:number=null;
  userName="";

  private clickTimeout: any = null;
  private delay = 250;
  person:BOPerson;
  toothFaceTypeList: BOToothFaceType[];
  toothStateTypeList:BOToothStateType[];
  toothStateList    :BOToothStateDetail[];
  toothSdAgroupedByToothType: BOToothStateDetailAgrouped[]=[];
  isQuote:boolean=false;

  // NUEVA PROPIEDAD: Rastrear qué icono está seleccionado en cada diente
  // Estructura: { toothId: indexDelIconoSeleccionado }
  selectedIconsByTooth: { [toothId: number]: number } = {};



//#region Triage Variables
//#region margen  Up Adulto  Variables

 u18=0;
 n18=0;
 b18=0;

 u17=0;
 n17=0;
 b17=0;

 u16=0;
 n16=0;
 b16=0;

 u15=0;
 n15=0;
 b15=0;

 u14=0;
 n14=0;
 b14=0;

 u13=0;
 n13=0;
 b13=0;

 u12=0;
 n12=0;
 b12=0;

 u11=0;
 n11=0;
 b11=0;

 u21=0;
 n21=0;
 b21=0;

 u22=0;
 n22=0;
 b22=0;

 u23=0;
 n23=0;
 b23=0;

 u24=0;
 n24=0;
 b24=0;

 u25=0;
 n25=0;
 b25=0;

 u26=0;
 n26=0;
 b26=0;

 u27=0;
 n27=0;
 b27=0;

 u28=0;
 n28=0;
 b28=0;


 ut18=0;
 nt18=0;
 bt18=0;

 ut17=0;
 nt17=0;
 bt17=0;

 ut16=0;
 nt16=0;
 bt16=0;

 ut15=0;
 nt15=0;
 bt15=0;

 ut14=0;
 nt14=0;
 bt14=0;

 ut13=0;
 nt13=0;
 bt13=0;

 ut12=0;
 nt12=0;
 bt12=0;

 ut11=0;
 nt11=0;
 bt11=0;

 ut21=0;
 nt21=0;
 bt21=0;

 ut22=0;
 nt22=0;
 bt22=0;

 ut23=0;
 nt23=0;
 bt23=0;

 ut24=0;
 nt24=0;
 bt24=0;

 ut25=0;
 nt25=0;
 bt25=0;

 ut26=0;
 nt26=0;
 bt26=0;

 ut27=0;
 nt27=0;
 bt27=0;

 ut28=0;
 nt28=0;
 bt28=0;

 //#endregion  Up  Adult Variables

  //#region   Up  child Variables

 u51=0;
 n51=0;
 b51=0;

 u52=0;
 n52=0;
 b52=0;

 u53=0;
 n53=0;
 b53=0;

 u54=0;
 n54=0;
 b54=0;

 u55=0;
 n55=0;
 b55=0;

 u61=0;
 n61=0;
 b61=0;

 u62=0;
 n62=0;
 b62=0;

 u63=0;
 n63=0;
 b63=0;

 u64=0;
 n64=0;
 b64=0;

 u65=0;
 n65=0;
 b65=0;


 ut51=0;
 nt51=0;
 bt51=0;

 ut52=0;
 nt52=0;
 bt52=0;

 ut53=0;
 nt53=0;
 bt53=0;

 ut54=0;
 nt54=0;
 bt54=0;

 ut55=0;
 nt55=0;
 bt55=0;

 ut61=0;
 nt61=0;
 bt61=0;

 ut62=0;
 nt62=0;
 bt62=0;

 ut63=0;
 nt63=0;
 bt63=0;

 ut64=0;
 nt64=0;
 bt64=0;

 ut65=0;
 nt65=0;
 bt65=0;


 //#endregion  Up  child  Variables

//#region   Up  child Variables

 u71=0;
 n71=0;
 b71=0;

 u72=0;
 n72=0;
 b72=0;

 u73=0;
 n73=0;
 b73=0;

 u74=0;
 n74=0;
 b74=0;

 u75=0;
 n75=0;
 b75=0;

 u81=0;
 n81=0;
 b81=0;

 u82=0;
 n82=0;
 b82=0;

 u83=0;
 n83=0;
 b83=0;

 u84=0;
 n84=0;
 b84=0;

 u85=0;
 n85=0;
 b85=0;



 ut71=0;
 nt71=0;
 bt71=0;

 ut72=0;
 nt72=0;
 bt72=0;

 ut73=0;
 nt73=0;
 bt73=0;

 ut74=0;
 nt74=0;
 bt74=0;

 ut75=0;
 nt75=0;
 bt75=0;

 ut81=0;
 nt81=0;
 bt81=0;

 ut82=0;
 nt82=0;
 bt82=0;

 ut83=0;
 nt83=0;
 bt83=0;

 ut84=0;
 nt84=0;
 bt84=0;

 ut85=0;
 nt85=0;
 bt85=0;

 //#endregion  Up  child  Variables

//#region  Bottom  Adulto Variables

 u31=0;
 n31=0;
 b31=0;

 u32=0;
 n32=0;
 b32=0;

 u33=0;
 n33=0;
 b33=0;

 u34=0;
 n34=0;
 b34=0;

 u35=0;
 n35=0;
 b35=0;

 u36=0;
 n36=0;
 b36=0;

 u37=0;
 n37=0;
 b37=0;

 u38=0;
 n38=0;
 b38=0;
 /////

 u41=0;
 n41=0;
 b41=0;

 u42=0;
 n42=0;
 b42=0;

 u43=0;
 n43=0;
 b43=0;

 u44=0;
 n44=0;
 b44=0;

 u45=0;
 n45=0;
 b45=0;

 u46=0;
 n46=0;
 b46=0;

 u47=0;
 n47=0;
 b47=0;

 u48=0;
 n48=0;
 b48=0;


 ut31=0;
 nt31=0;
 bt31=0;

 ut32=0;
 nt32=0;
 bt32=0;

 ut33=0;
 nt33=0;
 bt33=0;

 ut34=0;
 nt34=0;
 bt34=0;

 ut35=0;
 nt35=0;
 bt35=0;

 ut36=0;
 nt36=0;
 bt36=0;

 ut37=0;
 nt37=0;
 bt37=0;

 ut38=0;
 nt38=0;
 bt38=0;

 ut41=0;
 nt41=0;
 bt41=0;

 ut42=0;
 nt42=0;
 bt42=0;

 ut43=0;
 nt43=0;
 bt43=0;

 ut44=0;
 nt44=0;
 bt44=0;

 ut45=0;
 nt45=0;
 bt45=0;

 ut46=0;
 nt46=0;
 bt46=0;

 ut47=0;
 nt47=0;
 bt47=0;

 ut48=0;
 nt48=0;
 bt48=0;



 triageVariables: { [key: string]: { u: string, n: string, b: string, ut:string, nt:string, bt:string } } = (() => {
    const result: { [key: string]: { u: string, n: string, b: string, ut:string, nt:string, bt:string } } = {};

  // Generamos los números del 11 al 75 y del 81 al 85
  for (let i = 1; i <= 8; i++) {
    for (let j = 1; j <= 8; j++) {
      // Solo consideramos combinaciones válidas: 11-18, 21-28, 31-38, 41-48, 51-58, 61-68, 71-75, 81-85
      if (i === 7 && j > 5) continue; // Para el 7, solo vamos hasta 75
      if (i === 8 && j > 5) continue; // Para el 8, solo vamos hasta 85

      const key = `${i}${j}`;
      result[key] = {
        u: `u${key}`,
        n: `n${key}`,
        b: `b${key}`,
        ut: `ut${key}`,
        nt: `nt${key}`,
        bt: `bt${key}`

      };
    }
  }

  return result;
})();

//#endregion UNB


  constructor(
                private _renderer: Renderer2,
                private _toothFaceType      : ToothFaceTypeService,
                private _toothStateDetail   : ToothStateDetailService,
                private _toothStateType     : ToothStateTypeService,
                private _toastr             : ToastrService,
                private _route              : ActivatedRoute,
                private _router             : Router,
                private _person             : PersonService,
                private _changeDetectorRef : ChangeDetectorRef,

  ) {}

  ngOnInit(): void
  {
   console.log('Entra al ngOninit de odontograma');
    this._route.queryParams.pipe(
          take(1)
        ).subscribe(params => {
          if (params['clinicHistory']) {
            this.clinicHistoryId = +params['clinicHistory']; // Convertir a número
          };

          if (params['personId']) {
            this.personId = +params['personId']; // Convertir a número
          };
        });

      this.busyData$ = forkJoin({
        resultToothFaceType    : this._toothFaceType.getAll(),
        resultToothStateType   : this._toothStateType.getAll(),
        resultToothStateDetails: this._toothStateDetail.getToothStateDetailsByClinicHistoryIdPersonId(this.clinicHistoryId, this.personId),

       resultPerson           : this._person.getPerson(this.personId),

      }).subscribe({
        next: ({
          resultToothFaceType,
          resultToothStateType,
          resultToothStateDetails,
          resultPerson,

        }) => {
          this. toothFaceTypeList=resultToothFaceType;
          this.toothStateTypeList = resultToothStateType;
          this.toothStateList= resultToothStateDetails;
          this.person=resultPerson;
          this.personDocumentId=parseInt(this.person.personId);
          console.log(' this.toothStateList es:',  this.toothStateList);
          // console.log(' this.person es:',  this.person);
          this.toothSdAgroupedByToothType=this.groupByToothTypeIdWithKeys();
          ///
          if(this.toothSdAgroupedByToothType)
          {
            this.showAllFacesTeeth(this.toothSdAgroupedByToothType);
            this.initializeSelectedIcons(); // ✅ Inicializar selecciones de iconos
          }

         //console.log('En odontograma2 this.toothSdAgroupedByToothType is:', this.toothSdAgroupedByToothType);

          // this.sumTriagesInAgrouped(this.toothSdAgroupedByToothType);
          // this.updateTriageValues(this.toothSdAgroupedByToothType);
          this.userName=Utilities.getNameFromPersonByData(this.person.firstName, this.person.secondName, this.person.firtsSurName,this.person.secondSurName);

          //enable quote
          if(this.toothStateList.length>0) this.isQuote=true;


          //console.log('En odontograma this.toothStateTypeList is:', this.toothStateTypeList);
          //console.log('En odontograma this.toothStateList is:', this.toothStateList);
         console.log('En odontograma this.toothSdAgroupedByToothType is:', this.toothSdAgroupedByToothType);
         // this.actualizarColoresCircles();

        },
        error: (err) => {
          console.error('Error al cargar los datos: ', err);
        },
        complete: () => {
          console.log('Carga de datos completa');
        }
      });


  }



  ngAfterViewInit(): void {
   // console.log("Componente hijo inicializado:", this.toothState);

  }

onDataUpdated(toothId: number, tsd: BOToothStateDetail): void {
  console.log("=== onDataUpdated ===, la tsd es:", tsd);
  console.log ("tsd.tootStateId es:", tsd.toothStateId);
    if (!tsd?.toothStateId) {
    console.error('❌ tsd.toothStateId es requerido para renderizar el icono');
    return;
  }

  //verifica si es un diente nuevo
  //let verifica=this.toothSdAgroupedByToothType.find(x=>(x.toothTypeId==toothId));

  console.log("toothId buscado:", toothId);
  console.log("Array ANTES:", JSON.parse(JSON.stringify(this.toothSdAgroupedByToothType)));

  const oldRef = this.toothSdAgroupedByToothType;

  this.toothSdAgroupedByToothType = this.toothSdAgroupedByToothType.map(tsda => {
    if (tsda.toothTypeId === toothId)
    {
      console.log("✓ Coincidencia encontrada, actualizando items...");
      const newItems = [...(tsda.items || []), tsd];
      console.log("Items nuevos (longitud):", newItems.length);
      return { ...tsda, items: newItems };
    }
    return tsda;
  });

  if(this.toothSdAgroupedByToothType.length==0)
  {
   // this.resetSvgStyles(toothId.toString().trim());

  }

  console.log("¿Cambió la referencia del array padre?", oldRef !== this.toothSdAgroupedByToothType);
  console.log("Array DESPUÉS:", JSON.parse(JSON.stringify(this.toothSdAgroupedByToothType)));
 this.showFacesFromIcon2(toothId, this.toothSdAgroupedByToothType);
  this._changeDetectorRef.detectChanges();
}

onStateUpdated(toothId: number, tsd: BOToothStateDetail): void {
  console.log('=== onSTATEUPDATED ===');
  console.log('toothId recibido:', toothId, '| tipo:', typeof toothId);
  console.log('tsd recibido:', tsd);

  if (!tsd?.toothStateId) {
    console.error('❌ tsd.toothStateId es requerido');
    return;
  }
    const oldRef = this.toothSdAgroupedByToothType;

  // ✅ Forzar conversión a number para evitar type mismatch
  const targetToothId = Number(toothId);
  const targetTsdId   = Number(tsd.id);

  console.log('🔍 Buscando toothTypeId === ', targetToothId);
  console.log('🔍 IDs disponibles en array:',
    this.toothSdAgroupedByToothType.map(t => `${t.toothTypeId}(${typeof t.toothTypeId})`));

  this.toothSdAgroupedByToothType = this.toothSdAgroupedByToothType.map(tsda => {

    // ✅ Comparación segura con Number()
    if (Number(tsda.toothTypeId) !== targetToothId) {
      return tsda;
    }

    console.log('✅ Diente encontrado! toothTypeId:', tsda.toothTypeId);
    console.log('Items actuales:', tsda.items.map(i => `id:${i.id}`));

    const existingIndex = tsda.items.findIndex(ts => Number(ts.id) === targetTsdId);
    console.log('existingIndex:', existingIndex);

    let newItems: BOToothStateDetail[];

    if (existingIndex >= 0) {
      console.log('🔄 Reemplazando item existente en índice:', existingIndex);
      newItems = tsda.items.map((ts, idx) => idx === existingIndex ? { ...tsd } : ts);
    } else {
      console.log('➕ Agregando nuevo item');
      newItems = [...tsda.items, { ...tsd }];
    }
    this. fillSvgStyles(toothId.toString().trim());
    return { ...tsda, items: newItems };
  });

  // ✅ Mover los logs DESPUÉS de la asignación
  console.log('¿Cambió la referencia?', oldRef !== this.toothSdAgroupedByToothType);
  console.log('Array DESPUÉS:', JSON.parse(JSON.stringify(this.toothSdAgroupedByToothType)));
  this.showFacesFromIcon2(toothId, this.toothSdAgroupedByToothType);

  this._changeDetectorRef.markForCheck();
}

onDataUpdatedSmaller(toothId: number, tsd: BOToothStateDetail): void
{
  console.log("=== onDataUpdatedSmaller ===, la tsd es:", tsd);
  console.log ("tsd.tootStateId es:", tsd.toothStateId);
    if (!tsd?.toothStateId) {
    console.error('❌ tsd.toothStateId es requerido para renderizar el icono');
    return;
  }

  //verifica si es un diente nuevo
  //let verifica=this.toothSdAgroupedByToothType.find(x=>(x.toothTypeId==toothId));

  console.log("toothId buscado:", toothId);
  console.log("Array ANTES:", JSON.parse(JSON.stringify(this.toothSdAgroupedByToothType)));

  const oldRef = this.toothSdAgroupedByToothType;
  let tsdAItem:  BOToothStateDetailAgrouped=new BOToothStateDetailAgrouped();
  tsdAItem.toothTypeId=toothId;
  tsdAItem.items[0]=tsd;


  this.toothSdAgroupedByToothType.push(tsdAItem);
  this.toothSdAgroupedByToothType=[...  this.toothSdAgroupedByToothType];


  console.log("¿Cambió la referencia del array padre?", oldRef !== this.toothSdAgroupedByToothType);
  console.log("Array DESPUÉS:", JSON.parse(JSON.stringify(this.toothSdAgroupedByToothType)));
 this.showFacesFromIcon2(toothId, this.toothSdAgroupedByToothType);
  this._changeDetectorRef.detectChanges();
}

onStateErased(toothId: number, stateId: number): void {
  console.log(`🗑️ Eliminando stateId ${stateId} del tooth ${toothId}`);
  console.log('Al entrar a onStateErased, this.toothSdAgroupedByToothType es:', this.toothSdAgroupedByToothType);

  const toothIdNum  = Number(toothId);
  const stateIdNum  = Number(stateId);

  this.toothSdAgroupedByToothType = this.toothSdAgroupedByToothType.map(tsda => {

    if (Number(tsda.toothTypeId) === toothIdNum) {

      console.log(`✅ Grupo encontrado: toothTypeId=${tsda.toothTypeId}. Items antes:`, tsda.items.length);

      const filteredItems = tsda.items.filter(item => Number(item.toothStateId) !== stateIdNum);

      console.log(`   Items después del filtro:`, filteredItems.length);

      if (tsda.items.length === 1) {
        console.log('ℹ️ Era el último item del grupo, el grupo quedará vacío.');

        this.resetSvgStyles(toothId.toString().trim());

      }

      // Retorna nuevo objeto con items actualizados
    console.log("tsSdTSa SALE CON CAMBIOS");

      return { ...tsda, items: filteredItems };
    }

    // Retorna el mismo objeto sin cambios
    console.log("tsSdTSa SALE SIN CAMBIOS");
    return tsda;
  });

  // ✅ Notificamos a Angular (recomendado con OnPush)
  this._changeDetectorRef.markForCheck();

  console.log('✅ Array padre actualizado:', this.toothSdAgroupedByToothType);

  // ✅ Actualizamos las caras una sola vez, después de procesar todo el array
  this.showFacesFromIcon2(toothId, this.toothSdAgroupedByToothType);

}
private refreshToothFromStateChange(toothId:number, stateId:number)
{
  this. resetSvgStyles(toothId.toString().trim());
  //
}

// Método para refrescar el odontograma
private refreshOdontograma(): void
{
  console.log("Entra a refreshOdontograma");
  this.busyData$ = forkJoin({
    resultToothFaceType: this._toothFaceType.getAll(),
    resultToothStateType: this._toothStateType.getAll(),
    resultToothStateDetails: this._toothStateDetail.getToothStateDetailsByClinicHistoryIdPersonId(this.clinicHistoryId, this.personId),
    resultPerson: this._person.getPerson(this.personId),
  }).subscribe({
    next: ({
      resultToothFaceType,
      resultToothStateType,
      resultToothStateDetails,
      resultPerson,
    }) => {
      this.toothFaceTypeList = resultToothFaceType;
      this.toothStateTypeList = resultToothStateType;
      this.toothStateList = resultToothStateDetails;
      this.person = resultPerson;

      console.log('this.toothStateList es:', this.toothStateList);
      console.log('this.person es:', this.person);

      this.toothSdAgroupedByToothType = this.groupByToothTypeIdWithKeys();
      console.log('En odontograma2 this.toothSdAgroupedByToothType is:', this.toothSdAgroupedByToothType);

      // this.sumTriagesInAgrouped(this.toothSdAgroupedByToothType);
      // this.updateTriageValues(this.toothSdAgroupedByToothType);

      console.log('En odontograma this.toothStateList is:', this.toothStateList);
      console.log('En odontograma this.toothSdAgroupedByToothType is:', this.toothSdAgroupedByToothType);

        //enable quote
        if(this.toothStateList.length>0) this.isQuote=true;

    //  this.actualizarColoresCircles();
        if(this.toothSdAgroupedByToothType)
        {
          this.showAllFacesTeeth(this.toothSdAgroupedByToothType);
          this.initializeSelectedIcons(); // ✅ Inicializar selecciones de iconos
        }
      // Forzar detección de cambios
      this._changeDetectorRef.detectChanges();
    },
    error: (err) => {
      console.error('Error al cargar los datos: ', err);
    },
    complete: () => {
      console.log('Carga de datos completa');
    }
  });
}

  captureImage(event: any): any
  {
    console.log('Entra a captureImage');
    this.bridgeElement=null;
    //var upElement:HTMLElement = new HTMLElement();
    let target = event.target || event.srcElement || event.currentTarget;
     if (target.tagName === 'path' || target.tagName === 'circle')
     {
      let idAttr = target.getAttribute('id');
      let idSvg = target.getAttribute('data-svg-id');

        if (idAttr && idSvg) {
            console.log('ID del elemento:', idAttr, ' | ID del SVG:', idSvg);

            // Selecciona el SVG contenedor
            const svgContainer = document.getElementById(idSvg);

            // Busca el elemento dentro del SVG
            this.bridgeElement= svgContainer?.querySelector(`#${idAttr}`) as HTMLElement;
            console.log("upElement es:", this.bridgeElement);
            console.log("fill es:", this.bridgeElement.style.fill);
            //var color=upElement.style.fill;
        } else {
        console.log('Clic fuera de un path o rect:', target);
        }
      }
      return this.bridgeElement;

  }

  stateVerify(color:string, target: HTMLElement): string {
    switch (color) {
      case 'none':
        target.style.fill='red';
        return 'El estado es rojo';
      case 'red':
        target.style.fill='blue';
        return 'El estado es azul';
      case 'blue':
        target.style.fill='none';
        return 'El estado ha sido completado.';
      default:
        return 'Estado ninguno';
    }
  }

  changeColor(event: MouseEvent): void {
    console.log('Entra a changeColor->Click');

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout); // Cancela el temporizador si hay un doble clic
      this.clickTimeout = null;
      return;
    }

    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null; // Reinicia la variable

      const target = this.captureImage(event) as HTMLElement;
      if (target) {
        const color = target.style.fill;
        this.stateVerify(color, target);
      }
    }, this.delay);
  }

  changeStrokeColor(event: MouseEvent): void {
    console.log('Entra a changeStrokeColor->DobleClick');

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout); // Cancela el temporizador del clic simple
      this.clickTimeout = null;
    }

    const target = this.captureImage(event) as HTMLElement;
    if (target) {
      const strokeColor = target.style.stroke;
      console.log('strokeColor es:', strokeColor);

      if(strokeColor=='black')
      {
        target.style.stroke='red';
        target.style.strokeWidth='4';
      }
      else{
        target.style.stroke='black';
        target.style.strokeWidth='4';

      }
    }
  }

  showModal2(event:MouseEvent, clinicHistoryId:number): void {
    let toothId=this.getToothId(event);
    let positionInMouth=this.getPositionInMouth(event);

    if (this.toothState) {
      this.toothState.openModalFromOdontograma(clinicHistoryId,this.personId, toothId, positionInMouth);
      console.log("En showModal personId es:", this.personId);
    } else {
      console.error("No se encontró el componente FirstExam.");
    }
  }

  getToothId(event:MouseEvent):string{
    const toothElement=(event.target as Element).closest('svg');

    if (!toothElement) {
      console.error('No se encontró el elemento SVG diente');
      return;
    }
    // Capturar el id del SVG
  const svgId = toothElement.id;
  console.log('ID del toothElement SVG:', svgId);
  return svgId;
  }


  getPositionInMouth(event:any):string
  {
    const toothElement=event.target || event.srcElement || event.currentTarget;
    // const idElem=toothElement.getAttribute('id');
    const idElem=toothElement.getAttribute('id');

    console.log('En getPositionInMouth id is:', idElem);
    const targetElement=document.getElementById(idElem);
    if (!toothElement) {
      console.error('No se encontró el elemento SVG diente');
      return;
    }
    else console.log('pathCapturado es:', targetElement);
    // Capturar el id del SVG
  const pathPosition = targetElement.getAttribute('data-id-position')
  console.log('position del toothElement SVG:', pathPosition);
  return pathPosition;
  }

  groupByToothTypeIdWithKeys(): BOToothStateDetailAgrouped[] {
    const groupedObj: { [key: number]: BOToothStateDetail[] } = {};
    this.toothStateList.forEach(item =>
    {
      const key = item.toothTypeId;
      if (!groupedObj[key]) {
        groupedObj[key] = [];
      }
      groupedObj[key].push(item);
    });

    // Convertir a array de objetos con toothTypeId, items y triage
    const groupedArray: BOToothStateDetailAgrouped[] = Object.entries(groupedObj).map(([toothTypeId, items]) => ({
      toothTypeId: Number(toothTypeId),
      items,
      triage: [
        { id: 'u', numTriage: 0 },
        { id: 'n', numTriage: 0 },
        { id: 'b', numTriage: 0 },
        { id: 'ut', numTriage: 0 },
        { id: 'nt', numTriage: 0 },
        { id: 'bt', numTriage: 0 },

      ]
    }));

    return groupedArray;
  }

  updateTriageValues(gItems:BOToothStateDetailAgrouped[]): void {
      // Para cada elemento en gItems
      gItems.forEach(item => {
        const toothId = item.toothTypeId.toString();

        // Verificamos si tenemos variables definidas para este diente
        if (this.triageVariables[toothId]) {
          // Obtenemos los nombres de las variables
          const uVar = this.triageVariables[toothId].u;
          const nVar = this.triageVariables[toothId].n;
          const bVar = this.triageVariables[toothId].b;

          const utVar = this.triageVariables[toothId].ut;
          const ntVar = this.triageVariables[toothId].nt;
          const btVar = this.triageVariables[toothId].bt;


          // Asignamos los valores de triage a las variables correspondientes
          this[uVar] = item.triage[0].numTriage;
          this[nVar] = item.triage[1].numTriage;
          this[bVar] = item.triage[2].numTriage;

          this[utVar] = item.triage[3].numTriage;
          this[ntVar] = item.triage[4].numTriage;
          this[btVar] = item.triage[5].numTriage;
        }
      });
  }

  private initializeVariables() {
    // Inicializa todas las variables para los rangos especificados
    for (let i = 1; i <= 8; i++) {
      for (let j = 1; j <= 8; j++) {
        // Aplicamos las restricciones para los rangos dentales
        if (i === 7 && j > 5) continue; // Para el 7, solo vamos hasta 75
        if (i === 8 && j > 5) continue; // Para el 8, solo vamos hasta 85

        const key = `${i}${j}`;

        // Creamos las tres variables para cada diente
        (this as any)[`u${key}`] = 0;
        (this as any)[`n${key}`] = 0;
        (this as any)[`b${key}`] = 0;
      }
    }
  }

  actualizarColoresCircles()
  {
    console.log('Entra a actualizarColoresCircle');
      this.svgContainers.forEach(svgRef => {
        const svgElement = svgRef.nativeElement;
        const svgId = svgElement.id; // Obtenemos el ID (por ejemplo "18" o "17")

        // Obtenemos los valores correspondientes a este diente
        const u = this[`u${svgId}`] as number;
        const n = this[`n${svgId}`] as number;
        const b = this[`b${svgId}`] as number;

        const ut = this[`ut${svgId}`] as number;
        const nt = this[`nt${svgId}`] as number;
        const bt = this[`bt${svgId}`] as number;

        const circle = svgElement.querySelector(`circle[data-svg-id="${svgId}"]`);

        if (!circle) return;

        // Configuración de estilos
        const BASE_STYLE = {
          display: 'inline',
          stroke: 'black',
          strokeWidth: '2.002',
          strokeOpacity: '0.644022',
        };

        const applyCircleStyle = (
          fill: string,
          fillOpacity: string,
          additionalStyles: Record<string, string> = {}
        ) => {
          const style = {
            ...BASE_STYLE,
            fill,
            fillOpacity,
            ...additionalStyles
          };

          const styleString = Object.entries(style)
            .map(([key, value]) => `${key}:${value}`)
            .join(';');

          circle.setAttribute('style', styleString);
        };

        // Lógica de condiciones
        const allValuesMatchTargets = u === ut && n === nt && b === bt;
        const uExceedsTarget = u > ut;
        const uMatchesTargetOrZero = u === 0 || u === ut;
        const nExceedsTarget = n > nt;
        const nMatchesTargetOrZero = n === 0 || n === nt;
        const bExceedsTarget = b > bt;

        if (allValuesMatchTargets) {
          const isAllZero = u === 0 && n === 0 && b === 0;
          applyCircleStyle(
            isAllZero ? 'none' : 'green',
            '0.3'
          );
        } else if (uExceedsTarget) {
          applyCircleStyle('red', '0.6');
        } else if (uMatchesTargetOrZero) {
          if (nExceedsTarget) {
            applyCircleStyle('orange', '0.6');
          } else if (n === nt && bExceedsTarget) {
            applyCircleStyle('#15508a', '0.6');
          } else if (nMatchesTargetOrZero && b > 0) {
            if (bExceedsTarget) {
              applyCircleStyle('blue', '0.6');
            } else if (b === bt) {
              applyCircleStyle('green', '0.6');
            }
          }
        }
    });

  }

  navigateToQuoteFromOdontograma(clinicHistoryId:number, personId:number, personName:string, odontoId?:number)
  {

  console.log('Valores:', {
    clinicHistoryId,
    personId,
    personName,
    odontoId,
    tipo: typeof personName  // Verifica tipo
  });


      this._router.navigate(['/dental-Admins/quote'], {

        queryParams: {
          clinicHistory: clinicHistoryId,
          personId: personId,
          userName:personName,
          odontogramaId:odontoId
        }
      });
    }

  navigateToQuoteFromOdontograma2(clinicHistoryId:number, personId:number, personName:string, isQuoteWithOdontograma?:boolean, personDocumentId?:number)
  {
    console.log("Entra a navigateToQuoteFromOdontograma");
     console.log('Valores:', {
    clinicHistoryId,
    personId,
    personName,
    isQuoteWithOdontograma,
    personDocumentId,
    tipo: typeof personName  // Verifica tipo
  });


      this._router.navigate(['/dental-Admins/quote'], {

        state: {
          clinicHistoryId: clinicHistoryId,
          personId: personId,
          userName:personName,
         isQuoteWithOdontograma:isQuoteWithOdontograma,
         action: 'openToothQuote',  // ← trigger para ejecutar
         personDocumentId:personDocumentId
        }

      });

  }


  handleToothStateChangeFromIcon(tooth:{toothId:number,stateId:number, label:string,iconIndex:number}):void
  {
      console.log("Entra handleToothStateChangeFromIcon, toothSdAgroupedByToothType es:", this.toothSdAgroupedByToothType);

      console.log('Diente capturado:', tooth.toothId,' Estado:' ,tooth.stateId,' NombreEstado', tooth.label );
      // Actualizar el icono seleccionado para este diente
      this.selectedIconsByTooth[tooth.toothId] = tooth.iconIndex;

      console.log(`Icono seleccionado - Diente: ${tooth.toothId}, Índice: ${tooth.iconIndex}, Estado: ${tooth.label}`);
     //this.selectedIconsByTooth[event.toothId] = event.iconIndex;
      this.showFacesFromIcon(tooth.toothId, tooth.stateId);
  }

  showFacesFromIcon(toothId:number, stateId:number):void
  {
     //captura las faces del diente y el estado
    // console.log("En showFaces Entra, toothSdAgroupedByToothType es:", this.toothSdAgroupedByToothType, " stateId:", stateId);
    const btsda=this.toothSdAgroupedByToothType.find(x=>x.toothTypeId==toothId);
    const list=btsda.items;
    //console.log("En showFaces, list es:", list);
    const stateChoosed=list.find(x=>x.toothStateId==stateId);
    console.log("stateChoosed es:", stateChoosed);
    //

     const faces=stateChoosed.toothFaces;
     console.log("Las faces del diente:", toothId, " Estado:", stateId, " Son:", faces);
    //borra faces actuales y asigna nuevas al diente
    this.showFaces(toothId.toString().trim(), faces);

  }


  showFacesFromIcon2(toothId:number, tsdA:BOToothStateDetailAgrouped[]):void
  {
     //captura las faces del diente y el estado
    console.log("En showFaces Entra, toothSdAgroupedByToothType es:", tsdA, " toothId es:", toothId);
    let btsda= tsdA.find(x=>(x.toothTypeId==toothId));

    if(btsda.items.length==0)
    {
      this.resetSvgStyles(toothId.toString().trim());

    }


   // const btsda=this.toothSdAgroupedByToothType[0];
    const list=btsda.items;
    //console.log("En showFaces, list es:", list);
    const stateChoosed=list[0];
    console.log("stateChoosed es:", stateChoosed);

    if(!stateChoosed){
        return;
    }
    const faces=stateChoosed.toothFaces;
     console.log("Las faces del diente:",  faces);
    //borra faces actuales y asigna nuevas al diente
    //let toothId2=stateChoosed.toothTypeId;
    this.showFaces(toothId.toString().trim(), faces);

  }

  showAllFacesTeeth(data:BOToothStateDetailAgrouped[])
  {

    this.toothSdAgroupedByToothType.forEach(x => {
      if (x.items?.length > 0) {
        const first = x.items[0];
        this.showFaces(first.toothTypeId.toString().trim(), first.toothFaces);
      }
    });
  }


  showFaces(svgId: string, faces: BOToothStateDetailToothFace[]): void
  {
      console.log("Entra a showFaces, svgId es:", svgId);

      // 1. Capturar el SVG por su id único
      const svgElement = document.getElementById(svgId) as unknown as SVGSVGElement;

      if (!svgElement) {
        console.warn(`SVG con id="${svgId}" no encontrado en el DOM`);
        return;
      }

      // 2. Seleccionar todos los elementos con data-faceId
      const faceElements = svgElement.querySelectorAll('[data-faceId]') as NodeListOf<SVGElement>;

      // 3. Resetear todos los elementos: USAR setStyle para estilos CSS inline
      faceElements.forEach(element => {
        this._renderer.setStyle(element, 'fill', 'none');
        this._renderer.setStyle(element, 'stroke', 'black');
        // Opcional: mantener opacity si es necesario
        // this._renderer.setStyle(element, 'fill-opacity', '0.99');
      });

      // 4. Aplicar estilos según el array de faces
      faces.forEach(face => {
        if (face.toothFaceId == null) {
          console.warn('Face sin toothFaceId definido:', face);
          return;
        }

        const selector = `[data-faceId="${face.toothFaceId}"]`;
        const targetElement = svgElement.querySelector(selector) as SVGElement;

        if (targetElement) {
          console.log("targetElement es:", targetElement);
          const fillColor = face.color ?? 'none';
          const strokeColor = face.strokeColor ?? 'black';

          // ✅ CLAVE: Usar setStyle para sobrescribir estilos inline CSS
          this._renderer.setStyle(targetElement, 'fill', fillColor);
          this._renderer.setStyle(targetElement, 'stroke', strokeColor);

          // Opcional: si necesitas mantener opacity, aplícalo también
          // this._renderer.setStyle(targetElement, 'fill-opacity', '0.99');
          // this._renderer.setStyle(targetElement, 'stroke-opacity', '0.644022');
        } else {
          console.warn(`No se encontró elemento con data-faceId="${face.toothFaceId}" en SVG id="${svgId}"`);
        }
      });
      this._changeDetectorRef.detectChanges();
      //  Eliminar esta línea: detectChanges() no es necesario para manipulación directa del DOM
      // this._changeDetectorRef.detectChanges();
  }

/**
   * ✅ NUEVO MÉTODO: Inicializar la selección
   * Por cada diente que tenga items, selecciona el primero (índice 0)
   */
  initializeSelectedIcons(): void {
    this.toothSdAgroupedByToothType.forEach(groupedTooth => {
      if (groupedTooth.items.length > 0) {
        this.selectedIconsByTooth[groupedTooth.toothTypeId] = 0;
      }
    });
    console.log('Iconos inicializados:', this.selectedIconsByTooth);
  }

 resetSvgStyles(svgId: string): void {
  console.log("Entra a resetSvgStyles");
    const svgElement = document.getElementById(svgId) as unknown as SVGSVGElement;

    if (!svgElement) {
      console.warn(`SVG con id "${svgId}" no encontrado`);
      return;
    }

    // Obtener todos los paths dentro del SVG
    const paths = svgElement.querySelectorAll('path');
    const circle=svgElement.querySelector('circle');

    paths.forEach((path: SVGPathElement) => {
      path.style.fill = 'none';
      path.style.stroke = '#010200';

      // Opcional: también puedes modificar los atributos inline si es necesario
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#010200');
    });
//circle
    circle.style.fill='none';
    circle.style.stroke='#010200';
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', '#010200');

    console.log(`Se procesaron ${paths.length} paths del SVG #${svgId}`);
 }

fillSvgStyles(svgId: string): void {
  const svgElement = document.getElementById(svgId) as unknown as SVGSVGElement;
  if (!svgElement) { console.warn(`SVG "${svgId}" no encontrado`); return; }

  const targetId = parseInt(svgId, 10);
  const tsda = this.toothSdAgroupedByToothType.find(x => x.toothTypeId === targetId);
  if (!tsda) { console.warn(`toothTypeId ${targetId} no encontrado`); return; }

  // ── DIAGNÓSTICO ──
  console.log('Items count:', tsda.items.length);
  console.log('Item[0] keys:', Object.keys(tsda.items[0] ?? {}));
  console.log('toothFaces:', tsda.items[0]?.toothFaces);

  const faceColorMap = new Map<string, { fill: string; stroke: string }>();

  tsda.items.forEach(item => {
    if (!item.toothFaces?.length) {
      console.warn('⚠️ item sin toothFaces:', item);
      return;
    }
    item.toothFaces.forEach(f => {
      faceColorMap.set(String(f.toothFaceId), { fill: f.color, stroke: f.strokeColor });
    });
  });

  console.log('faceColorMap.size:', faceColorMap.size); // ← Si es 0, problema en toothFaces
  console.log('faceColorMap keys:', [...faceColorMap.keys()]);

  // ── APLICAR A PATHS ──
  const paths = svgElement.querySelectorAll<SVGPathElement>('path');
  paths.forEach(p => {
    // ✅ Probar las dos variantes de case
    const faceId = p.getAttribute('data-faceid')   // minúsculas (HTML parser)
                ?? p.getAttribute('data-faceId');   // camelCase (fallback)

    console.log(`Path → faceId obtenido: "${faceId}" | mapa tiene: ${faceColorMap.has(String(faceId))}`);

    if (faceId && faceColorMap.has(faceId)) {
      const { fill, stroke } = faceColorMap.get(faceId)!;
      p.style.fill   = fill;
      p.style.stroke = stroke;
    }
  });

  // ── APLICAR AL CIRCLE ──
  const circle = svgElement.querySelector<SVGCircleElement>('circle');
  if (circle) {
    const faceId = circle.getAttribute('data-faceid') ?? circle.getAttribute('data-faceId');
    if (faceId && faceColorMap.has(faceId)) {
      const { fill, stroke } = faceColorMap.get(faceId)!;
      circle.style.fill   = fill;
      circle.style.stroke = stroke;
    }
  }

  this._changeDetectorRef.detectChanges();
}


trackByToothState(index: number, state: BOToothStateDetail): any {
  // Usa una propiedad única, o combina varias si no hay ID único
  return state?.toothStateDetailIdTemp ?? state?.id ?? `${index}-${state?.toothStateId}`;
}

// ✅ Ayuda a *ngFor a identificar qué items cambiaron
trackByStateId(index: number, state: BOToothStateDetail): number {
  return state.id; // usa el identificador único del item
}


trackByToothType(index: number, item: BOToothStateDetailAgrouped): number {
  return item.toothTypeId;
}

trackByStateIdIcon(index: number, item: BOToothStateDetail): number {
  return item.id ?? index;
}

ngOnDestroy(): void {
      this.busyData$?.unsubscribe();
}

}




